// if the app needs to refresh in certain cases, we want to be able to open back
// up to any modals or windows it came from
const refreshStates = {
  methods: {
    refreshState(state, fn) {
      const refreshState = window.localStorage.getItem('refreshState');
      if (refreshState === state) {
        fn();
      }
    },
  },
};

module.exports = {
  refreshStates,
};



// WEBPACK FOOTER //
// ./src/mixins/refresh-states.js